import useGetApi from 'src/api/useGetApi';
import { ProductV2DTO } from 'src/types/application/inventory-management/ProductV2DTO';

interface GetQueryParams {
  includes?: Array<'attributes'>;
}

interface GetProductResponse {
  product: ProductV2DTO;
}

export const useProduct = (
  productId?: string,
  params?: GetQueryParams,
  enabled?: boolean,
) => {
  return useGetApi<GetProductResponse>({
    endpoint: `inventory-management/products-v2/${productId}`,
    queryParameters: params,
    options: {
      enabled: enabled && !!productId,
    },
  });
};
